
//scroll down to search results when user clicks search or hits enter. instantsearch.js handles the actual submission/results
export const searchScroll = () => {
	const searchInputButton = document.querySelectorAll('.search-input-holder button');
	searchInputButton.forEach((button) => {
		button.addEventListener('click', (e) => {
			document.querySelector('#search-results').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest'});
		});
	});

	const searchInput = document.querySelectorAll('.search-input-holder input[type=search]');
	console.log(searchInput);
	searchInput.forEach((input) => {
		console.log(input);
		input.addEventListener('keydown', event => {
			if (event.key === 'Enter') {
				event.preventDefault();
				console.log('Enter key was pressed', document.querySelector('#search-results'));
				document.querySelector('#search-results').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest'});
			}
		});
	});

};
